<div class="bg-th-yellow mt-0 container-fluid">
  <div class="d-flex justify-content-between align-content-center h-35">
    <i class="fa fa-arrow-left text-dark my-auto pointer" routerLink="/"></i>
    <span class="my-auto f16 fw-bold me-2"> رتبه‌بندی رانندگان پرخطر </span>
  </div>
</div>

<div [formGroup]="searchForm" class="w-100 form rtl row gx-2 gy-2 p-4">
  <div class="col-12 col-md-3">
    <label> از تاریخ </label>

    <ng-persian-datepicker
      [uiTheme]="'gray'"
      [timeEnable]="false"
      [dateGregorianFormat]="'YYYY/MM/DD'"
      [dateInitValue]="true"
      [dateFormat]="'jYYYY/jMM/jDD'"
    >
      <input formControlName="strSDate" class="form-control text-end" />
    </ng-persian-datepicker>
  </div>

  <div class="col-12 col-md-3">
    <label> تا تاریخ </label>

    <ng-persian-datepicker
      [uiTheme]="'gray'"
      [timeEnable]="false"
      [dateGregorianFormat]="'YYYY/MM/DD'"
      [dateInitValue]="true"
      [dateFormat]="'jYYYY/jMM/jDD'"
    >
      <input formControlName="strEDate" class="form-control text-end" />
    </ng-persian-datepicker>
  </div>

  <div class="col-12 col-md-auto">
    <button class="w-100 btn btn-primary" (click)="fetchData()">
        جستجو
    </button>
  </div>

  <div class="col-12 px-2">
    <div class="border container-fluid row gx-0 gy-2 mt-3 p-2">
      <div class="col-12 p-1">
        <input class="w-100 form-control" placeholder="جستجو کنید ..." (input)="filterResult($event.target.value)" />
      </div>
      <div class="section border mt-2">
        <table class="col-12 table table-striped rounded-3" id="Export_Excel">
          <thead>
            <tr class="text-center">
              <th scope="col">#</th>
              <th scope="col">رتبه</th>
              <th scope="col">تانکر</th>
              <th scope="col">پلاک</th>
              <th scope="col">موبایل</th>
              <th scope="col">شاخص اعتماد </th>
            </tr>
          </thead>

          <tbody>
            <tr class="f14 text-center" [ngClass]="getTrustScoreClass(item.TrustScore)" *ngFor="let item of data; let i = index">
              <th class="text-dark">{{ i + 1 | faNum }}</th>
              <td>{{ item.Rank}}</td>
              <td>{{ item.strFullName }}</td>
              <td>{{ item.strVehicleNo }}</td>
              <td>{{ item.strMobile | faNum }}</td>
              <td>{{ item.ComplianceScore | faNum }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
